import { render, staticRenderFns } from "./swiper-search.vue?vue&type=template&id=9bccc924&scoped=true&"
import script from "./swiper-search.vue?vue&type=script&lang=js&"
export * from "./swiper-search.vue?vue&type=script&lang=js&"
import style0 from "./swiper-search.vue?vue&type=style&index=0&id=9bccc924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bccc924",
  null
  
)

export default component.exports